import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const SeasonContext = createContext();

export const SeasonProvider = ({ children }) => {
  const [seasons, setSeasons] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: 500,
    // limit: LIMIT_DATA_PER_PAGE,
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchSeasons = useCallback(async () => {
    setSeasons((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/season${queryString}`);
      if (response.success) {
        setSeasons({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setSeasons({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchSeasons();
  }, [fetchSeasons]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = seasons.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <SeasonContext.Provider
      value={{
        seasons,
        filterOptions,
        handleSearch,
        refetch: fetchSeasons,
        Pagination,
      }}
    >
      {children}
    </SeasonContext.Provider>
  );
};

export const useSeason = () => {
  const context = useContext(SeasonContext);
  if (!context) {
    throw new Error("useSeason must be used within SeasonProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/season?search=${inputValue}`);
    if (response.success) {
      return response.data.map((season) => ({
        value: season.id,
        label: season.name,
      }));
    }
    return [];
  };

  return { ...context, fetchOptions };
};
